import { gql } from "@apollo/client";

const inspire = gql`
  query inspire($query: String!) {
    inspire(query: $query) {
      question
      filters
    }
  }
`;
export default inspire;
